//Call_[npm_run_updateTestIndexes]_to_update_this_file.

// @create-index

module.exports = {
    DataAggregation: require('./DataAggregation'),
    FixedText: require('./FixedText'),
    ShortTextView: require('./ShortTextView'),
};


